import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCoffre = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 26,
	height: 28,
	viewBox: "0 0 26 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M23.6364 11.6667H22.4545V9.33333C22.4545 4.18444 18.2158 0 13 0C7.78424 0 3.54545 4.18444 3.54545 9.33333V11.6667H2.36364C1.05576 11.6667 0 12.7089 0 14V25.6667C0 26.9578 1.05576 28 2.36364 28H23.6364C24.9442 28 26 26.9578 26 25.6667V14C26 12.7089 24.9442 11.6667 23.6364 11.6667ZM10.2739 23.3333L11.8339 20.6578C11.1248 20.2533 10.6364 19.5378 10.6364 18.6667C10.6364 17.3756 11.6921 16.3333 13 16.3333C14.3079 16.3333 15.3636 17.3756 15.3636 18.6667C15.3636 19.5222 14.8752 20.2533 14.1661 20.6578L15.7261 23.3333H10.2739ZM18.9091 11.6667H7.09091V9.33333C7.09091 6.11333 9.73818 3.5 13 3.5C16.2618 3.5 18.9091 6.11333 18.9091 9.33333V11.6667Z",
		fill: "white"
	})
});
export default SvgCoffre;
